module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_03_770_280_th-ad11f8b3caf9b7f7c527a57bbb794e87.jpg";